import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MsalGuard } from '@azure/msal-angular';
import { AdminRequestComponent } from './admin/admin-request/admin-request.component';
import { ApprovalDashboardComponent } from './approval-dashboard/approval-dashboard/approval-dashboard.component';
import { ApprovalHistoryComponent } from './approval-history/approval-history/approval-history.component';
import { RequestStatusComponent } from './request-status-reports/request-status/request-status.component';
import { BulkRequestComponent } from './bulkrequest/bulk-request/bulk-request.component';
import { BulkRequestHistoryComponent } from './bulkrequest/bulk-request-history/bulk-request-history.component';
import { BulkRequestApprovalDashboardComponent } from './bulkrequest/bulk-request-approval-dashboard/bulk-request-approval-dashboard.component';
import { BulkRequestApprovalHistoryComponent } from './bulkrequest/bulk-request-approval-history/bulk-request-approval-history.component';
import { BulkRequestGbsHistoryComponent } from './bulkrequest/bulk-request-gbs-history/bulk-request-gbs-history.component';
import { BulkRequestGbsPendingComponent } from './bulkrequest/bulk-request-gbs-pending/bulk-request-gbs-pending.component';
import { BulkRequestReportsComponent } from './bulkrequest/bulk-request-reports/bulk-request-reports.component';

const routes: Routes = [
  { canActivate: [MsalGuard], path: '', component: DashboardComponent },
  { canActivate: [MsalGuard], path: 'dashboard', component: DashboardComponent },
    { canActivate: [MsalGuard], path: 'home', component: DashboardComponent },
    { canActivate: [MsalGuard], path: 'request-status-reports', component: RequestStatusComponent },
    {canActivate: [MsalGuard], path:'bulk-request',component:BulkRequestComponent},
    {canActivate: [MsalGuard], path:'bulk-request-history',component:BulkRequestHistoryComponent},
    {canActivate:[MsalGuard],path:'bulk-request-approvaldashboard',component:BulkRequestApprovalDashboardComponent},
    {canActivate:[MsalGuard],path:'bulk-request-approvalhistory',component:BulkRequestApprovalHistoryComponent},
    {canActivate:[MsalGuard],path:'bulk-request-gbshistory',component:BulkRequestGbsHistoryComponent},
    {canActivate:[MsalGuard],path:'bulk-request-gbspending',component:BulkRequestGbsPendingComponent},
    {canActivate:[MsalGuard],path:'bulk-request-reports',component:BulkRequestReportsComponent},
  {
    path: 'requests',
    loadChildren: () => import('./requests/requests.module').then(m => m.RequestsModule),
    canActivate: [MsalGuard]
  },
  {
    path: 'approval',
    loadChildren: () => import('./approval/approval.module').then(m => m.ApprovalModule),
    canActivate: [MsalGuard]
  },
  {
    path: 'gbs',
    loadChildren: () => import('./gbs/gbs.module').then(m => m.GBSModule),
    canActivate: [MsalGuard]
  },
  { canActivate: [MsalGuard], path: 'admin-request', component: AdminRequestComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
